import { Drawer } from '@mui/material'
import { useRef } from 'react'
import StyledPaper from '/components/paper'

// Reusable wrapper for editor popups. Default is transparent; set variant="solid" to add a stronger paper bg.
const PopupShell = ({ open, onClose, width = 520, children }) => {
  const focusRef = useRef(null)

  const closeMe = () =>{
    focusRef.current?.focus()
    onClose()
  }

  return (
    <>
      <Drawer
        open={open}
        anchor="right"
        onClose={closeMe}
        ModalProps={{ BackdropProps: { invisible: true, sx: { backgroundColor: 'transparent' } } }}
        slotProps={{
          backdrop: { invisible: true, sx: { backgroundColor: 'transparent' } },
          paper: { sx: { backgroundColor: 'transparent', boxShadow: 'none', backgroundImage: 'none', '--Paper-overlay': 'none' } },
        }}
        sx={{
          width,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width,
            boxSizing: 'border-box',
            paddingTop: 24,
            backgroundColor: 'transparent',
            backgroundImage: 'none',
            boxShadow: 'none',
            paddingLeft: "20px",
            '--Paper-overlay': 'none',
          },
        }}
      >
        <div className="h-full">
          <StyledPaper
            sx={{
              height: 'calc(100% - 15px)',
              overflow: 'hidden',
              ...({
                backgroundColor: (theme) => theme.palette.mode === 'dark'
                  ? 'rgba(0, 0, 0, 0.95)'
                  : 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(5px)',
              }),
            }}
          >
            {children}
          </StyledPaper>
        </div>
      </Drawer>
      <div ref={focusRef} tabIndex={-1}/>
    </>
  )
}

export default PopupShell
